package ui.device.detail.preview

import androidx.compose.foundation.*
import androidx.compose.foundation.gestures.*
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.geometry.*
import androidx.compose.ui.graphics.*
import androidx.compose.ui.input.pointer.*
import androidx.compose.ui.layout.*
import androidx.compose.ui.unit.*
import compose.assets.*
import compose.assets.svg.*
import io.*
import kotlinx.coroutines.*
import tk.mallumo.utils.*
import ui.device.detail.*
import ui.widget.*
import kotlin.math.*

private fun DevicePreviewScope.calculatePosition(windowSize: IntSize?, browserX: Float, browserY: Float): Offset? {
    return vm.state.entry?.data?.config?.display?.let { deviceDisplay ->
        windowSize?.let { browserWindow ->

            val xPct = browserX / browserWindow.width.toFloat()
            val yPct = browserY / browserWindow.height.toFloat()

            Offset(
                x = (deviceDisplay.width.toFloat() * xPct),
                y = (deviceDisplay.height.toFloat() * yPct)
            )
        }
    }
}

@Composable
fun DevicePreviewScope.ScreenshotDialog(state: DialogState, userId: Long, mac: String, captureMode: Int) {
    Dialog(state) {
        val scope = rememberCoroutineScope()
        val loadState = remember { mutableDataState<ImageBitmap>() }
        val windowSize = remember {
            mutableStateOf<IntSize?>(null)
        }
        val onDragInitial = remember {
            mutableStateOf<Offset?>(null)
        }

        val onDragLast = remember {
            mutableStateOf<Offset?>(null)
        }


        fun onDragEnd() {
            runCatching {
                windowSize.value?.also { window ->
                    onDragInitial.value?.also {
                        calculatePosition(window, it.x, it.y)?.also { initial ->
                            onDragLast.value?.also { target ->
                                val targetAmount = ((it.y - target.y) / window.height.toFloat()) * 15F
                                scope.launch {
                                    Repository.api.remoteScroll(mac, initial.x.roundToInt(), initial.y.roundToInt(), targetAmount.roundToInt())
                                }
                            }
                        }
                    }
                }
            }.onFailure {
                println("point calculation fail:")
                it.printStackTrace()
            }
        }

        Box(
            Modifier.fillMaxSize()
                .background(Color.DarkGray)
        ) {
            when (val dataState = loadState.value) {
                is DataState.Idle,
                is DataState.Loading -> {
                    CircularProgressIndicator(Modifier.align(Alignment.Center))
                }

                is DataState.Error -> {
                    Column(Modifier.align(Alignment.Center)) {
                        Text(dataState.message)
                        Space(16.dp)
                        ReloadButton(Modifier.align(Alignment.CenterHorizontally)) {
                            scope.launch(Dispatchers.Unconfined) {
                                Repository.api.screenshot(loadState, userId, mac, captureMode)
                            }
                        }
                    }
                }

                is DataState.Result -> {
                    Image(
                        bitmap = dataState.nnvl,
                        contentDescription = null,
                        contentScale = ContentScale.Inside,
                        modifier = Modifier
                            .align(Alignment.Center)
                            .onGloballyPositioned {
                                windowSize.value = it.size
                            }
                            .pointerInput(Unit) {
                                detectDragGestures(
                                    onDragStart = {
                                        onDragInitial.value = it
                                    },
                                    onDragEnd = {
                                        onDragEnd()
                                    },
                                    onDragCancel = {
                                        onDragEnd()
                                    },
                                    onDrag = { change, _ ->
                                        change.consume()
                                        onDragLast.value = change.position
                                    }
                                )
                            }
                            .pointerInput(Unit) {
                                detectTapGestures {
                                    runCatching {
                                        calculatePosition(windowSize.value, it.x, it.y)?.also {
                                            scope.launch {
                                                Repository.api.remoteTouch(mac, it.x.roundToInt(), it.y.roundToInt())
                                            }
                                        }
                                    }.onFailure {
                                        println("point calculation fail:")
                                        it.printStackTrace()
                                    }
                                }
                            }
                    )
                }
            }
            CloseButton {
                state.hide()
            }
        }
        LaunchedEffect(Unit) {
            Repository.api.screenshot(loadState, userId, mac, captureMode)
        }
    }
}

@Composable
private fun ReloadButton(modifier: Modifier = Modifier, onReload: () -> Unit) {
    FloatingActionButton(
        modifier = modifier,
        onClick = { onReload() }) {
        Icon(Svg.Refresh, null)
    }
}

@Composable
private fun BoxScope.CloseButton(onClose: () -> Unit) {
    FloatingActionButton(
        modifier = Modifier.align(Alignment.TopStart)
            .padding(8.dp),
        containerColor = MaterialTheme.colorScheme.errorContainer,
        onClick = { onClose() }) {
        Icon(Svg.Close, null)
    }
}
